/**
 * these directives are used in place of the ng-* directives because
 * the latter result in a $rootScope.digest call which is too
 * expensive in applications
 * instead these directives run the digest cycle on the $scope of the
 * calendar (including week and list view)
 */
angular
  .module('ui-ng-calendar')
  .directive('isolateDigestMouseover', function ($parse) {
    return {
      link: function (scope, element, attr) {
        var fn = $parse(attr['isolateDigestMouseover']);
        element.bind('mouseover', function (event) {
          fn(scope, { $event: event });
          scope.$parent.$digest();
        });
      }
    };
  })
  .directive('isolateDigestMousedown', function ($parse) {
    return {
      link: function (scope, element, attr) {
        var fn = $parse(attr['isolateDigestMousedown']);
        element.bind('mousedown', function (event) {
          fn(scope, { $event: event });
          scope.$parent.$digest();
        });
      }
    };
  })
  .directive('isolateDigestMouseup', function ($parse) {
    return {
      link: function (scope, element, attr) {
        var fn = $parse(attr['isolateDigestMouseup']);
        element.bind('mouseup', function (event) {
          fn(scope, { $event: event });
          scope.$parent.$digest();
        });
      }
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/performance/isolate_digest_directives.ts